import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

export type ModalType = 'createProject' | 'editProject' | 'createElement' | '';

interface ModalsState {
  isModalOpen: boolean;
  modalType: ModalType;
  props: Record<string, unknown> | null;
  
  // Actions
  closeModal: () => void;
  openModal: (type: ModalType, props?: Record<string, unknown>) => void;
}

export const useModalsStore = create<ModalsState>()(
  devtools(
    immer((set) => ({
      isModalOpen: false,
      modalType: '',
      props: null,

      closeModal: () => {
        set((state) => {
          state.modalType = '';
          state.isModalOpen = false;
          state.props = null;
        });
      },

      openModal: (type: ModalType, props?: Record<string, unknown>) => {
        set((state) => {
          state.modalType = type;
          state.isModalOpen = true;
          state.props = props ?? null;
        });
      },
    })),
    { name: 'ModalsStore' }
  )
);

if (typeof window !== 'undefined') {
  (window as any).useModalsStore = useModalsStore;
}